import PropTypes from 'prop-types'
import React from 'react'
import ClassNames from 'classnames'
import 'react-vis/dist/style.css'
import {
  makeWidthFlexible,
  XYPlot,
  XAxis,
  AreaSeries,
  LineSeries,
  Hint
} from 'react-vis'
import { connectivityLogForCharts } from 'modules/farmhand'
import { ConnectivityLogShape } from 'shapes'
import AreaHint from 'components/area-hint'
import ChartHintTimestamp from 'components/chart-hint-timestamp'
import './index.css'

const FlexibleXYPlot = makeWidthFlexible(XYPlot)

export class InputChart extends React.PureComponent {
  render () {
    const props = {
      ...this.props,
      chartHeight: 60,
      showAuto: false,
      className: 'input-chart'
    }
    return (
      <EquipmentChart {...props} />
    )
  }
}

class EquipmentChart extends React.PureComponent {
  static propTypes = {
    historicalData: PropTypes.object.isRequired,
    connectivityData: PropTypes.arrayOf(ConnectivityLogShape),
    xStart: PropTypes.string.isRequired,
    xEnd: PropTypes.string.isRequired,
    highlighted: PropTypes.shape({
      x: PropTypes.instanceOf(Date).isRequired,
      y: PropTypes.number.isRequired
    }),
    highlightX: PropTypes.func,
    chartHeight: PropTypes.number,
    showAuto: PropTypes.bool,
    className: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.string)
    ])
  }

  static defaultProps = {
    chartHeight: 80,
    showAuto: true,
    connectivityData: []
  }

  state = {
    isFocused: false
  }

  mouseEnterHandler = () => {
    this.setState({ isFocused: true })
  }

  mouseLeaveHandler = () => {
    this.props.highlightX(null)
    this.setState({ isFocused: false })
  }

  render () {
    const {
      historicalData,
      connectivityData,
      xStart,
      xEnd,
      highlighted,
      highlightX,
      showAuto
    } = this.props
    const { isFocused } = this.state

    const countToShow = showAuto ? 3 : 2

    const DATA_HEIGHT = 8
    const AUTO_HEIGHT = DATA_HEIGHT
    const ON_HEIGHT = AUTO_HEIGHT / countToShow * 2

    const firstDataPoint = historicalData.data[0]
    // Protects us when using old data source which lacks `change` values
    const firstChange = firstDataPoint.change || {}
    const initialState = {
      change: firstChange,
      state: {
        on: firstChange.on === firstDataPoint.state.on
          ? !firstDataPoint.state.on
          : firstDataPoint.state.on,
        auto: typeof firstChange.auto === 'boolean' && firstChange.auto === firstDataPoint.state.auto
          ? !firstDataPoint.state.auto
          : firstDataPoint.state.auto
      },
      timestamp: new Date(xStart)
    }

    const lastDataPoint = historicalData.data[historicalData.data.length - 1]
    const finalState = {
      change: lastDataPoint.change,
      state: {
        on: lastDataPoint.state.on,
        auto: lastDataPoint.state.auto
      },
      timestamp: new Date(xEnd)
    }

    const formattedHistoricalData = [initialState].concat(historicalData.data, [finalState])

    const formattedOnData = formattedHistoricalData.map(({state, timestamp}) => {
      return {
        x: timestamp,
        y: state.on ? ON_HEIGHT : 0
      }
    })
    const formattedAutoData = formattedHistoricalData.map(({state, timestamp}) => {
      return {
        x: timestamp,
        y: state.auto ? AUTO_HEIGHT : 0
      }
    })
    const formattedOffData = formattedHistoricalData.map(({state, timestamp}) => {
      return {
        x: timestamp,
        y: state.on ? 0 : ON_HEIGHT
      }
    })

    // not sure why this reverse() works -- it shouldn't need it but for some reason it does
    const formattedConnectivityData = connectivityLogForCharts(xStart, xEnd, connectivityData).reverse().map(({createdAt, sensorsOnline}) => {
      return {
        x: createdAt,
        y: !sensorsOnline ? DATA_HEIGHT : 0
      }
    })

    const className = ClassNames('equipment-chart', this.props.className)

    return (
      <div className={className}>
        <div className="y-axis">
          {showAuto ? <p className="auto-tick">auto</p> : null}
          <p className="on-tick">on</p>
          <p className="off-tick">off</p>
        </div>
        <FlexibleXYPlot
          height={this.props.chartHeight}
          xType="time"
          onMouseMove={this.mouseEnterHandler}
          onMouseLeave={this.mouseLeaveHandler}
          xDomain={[new Date(xStart), new Date(xEnd)]}
          yDomain={[0, DATA_HEIGHT]}
        >
          {showAuto ? <AreaSeries
            onNearestX={highlightX}
            stroke="none"
            fill="rgba(33, 202, 186, 0.25)"
            data={formattedAutoData}
            curve="curveStepAfter"
          /> : null}
          <AreaSeries
            onNearestX={highlightX}
            stroke="none"
            fill="#21CABA"
            data={formattedOnData}
            curve="curveStepAfter"
          />
          <AreaSeries
            onNearestX={highlightX}
            stroke="none"
            fill="#606671"
            data={formattedOffData}
            curve="curveStepAfter"
          />
          <AreaSeries
            stroke="none"
            fill="rgba(255,255,255, 0.9)"
            data={formattedConnectivityData}
            curve="curveStepAfter"
          />
          <XAxis tickTotal={6} />
          {highlighted ? (
            <LineSeries
              data={[
                {x: highlighted.x, y: 0},
                {x: highlighted.x, y: DATA_HEIGHT}
              ]}
              stroke="rgba(17, 147, 154, 0.7)"
              strokeWidth={2}
            />
          ) : null}
          {highlighted && isFocused ? (
            <Hint value={highlighted}>
              <AreaHint>
                <ChartHintTimestamp timestamp={highlighted.x} />
              </AreaHint>
            </Hint>
          ) : null}
        </FlexibleXYPlot>
      </div>
    )
  }
}

export default EquipmentChart



// WEBPACK FOOTER //
// /Users/alextaxiera/source/farmhand-server/client/dashboard/src/js/components/equipment-chart/index.js